import React from 'react'
import Table from '../Table';

export default function FdBandhan() {

    const fdInterestRates = [
        {
          MaturityBucket: "7 days to 14 days",
          RegularFDRates: "3.00%",
          SeniorCitizenRates: "3.75%"
        },
        {
          MaturityBucket: "15 days to 30 days",
          RegularFDRates: "3.00%",
          SeniorCitizenRates: "3.75%"
        },
        {
          MaturityBucket: "31 days to less than 2 months",
          RegularFDRates: "3.50%",
          SeniorCitizenRates: "4.25%"
        },
        {
          MaturityBucket: "2 months to less than 3 months",
          RegularFDRates: "4.50%",
          SeniorCitizenRates: "5.25%"
        },
        {
          MaturityBucket: "3 months to less than 6 months",
          RegularFDRates: "4.50%",
          SeniorCitizenRates: "5.25%"
        },
        {
          MaturityBucket: "6 months to less than 1 year",
          RegularFDRates: "4.50%",
          SeniorCitizenRates: "5.25%"
        },
        {
          MaturityBucket: "1 year to 499 days",
          RegularFDRates: "7.25%",
          SeniorCitizenRates: "7.75%"
        },
        {
          MaturityBucket: "500 days (1 year, 4 months, 11 days)",
          RegularFDRates: "7.85%",
          SeniorCitizenRates: "8.35%"
        },
        {
          MaturityBucket: "501 days to less than 2 years",
          RegularFDRates: "7.25%",
          SeniorCitizenRates: "7.75%"
        },
        {
          MaturityBucket: "2 years to less than 3 years",
          RegularFDRates: "7.25%",
          SeniorCitizenRates: "7.75%"
        },
        {
          MaturityBucket: "3 years to less than 5 years",
          RegularFDRates: "7.25%",
          SeniorCitizenRates: "7.75%"
        },
        {
          MaturityBucket: "5 years to up to 10 years",
          RegularFDRates: "5.85%",
          SeniorCitizenRates: "6.60%"
        }
      ];
      const mappedRatesList = fdInterestRates.map(rate => ({
        MaturityPeriod: rate.MaturityBucket,
        PublicInterestRate: rate.RegularFDRates,
        SeniorCitizen: rate.SeniorCitizenRates
      }));
      
  return (
    <section
    className="services-area bg-white pt-110  wow fadeInUp"
    style={{ display: "flex", flexDirection: "row" }}
  >
  <div
    className="container "
   
  
  >
    <div className="section-title mb-45">
<h1 className="ui header">Bandhan Bank FD Rates 2024</h1>
<p>Bandhan Bank offers Term Deposits or Fixed Deposits (FDs) with interest rates between 3.00% p.a. and 7.85% p.a. for domestic fixed deposits with senior citizens getting an additional interest rate of up to 0.75% p.a.

The interest rate will be applicable on the basis of the tenure of the FD which can range from 7 days to up to 10 years.</p>
<h4 className="ui header mt-30 ">Bandhan Bank NRI Fixed Deposit Rates
</h4>
<p>Non to Resident Indians (NRIs) can invest in Term Deposits or fixed deposit offered by Bandhan Bank. The FDs are available in three variants to Non to Resident External (NRE) FD, Non to Resident Ordinary (NRO) FD, and Foreign Currency Non to Resident (Bank) Deposit (FCNR (B)) schemes.

</p>
<h4 className='mt-20'>Bandhan Bank FD Rates in India – Below Rs.2 crore</h4>

<Table list1={mappedRatesList} />




</div>
</div>
</section>

)
}
